<template>
    <div>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item>
                    <i class='el-icon-lx-cascades'></i> 提现管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container'>

            <div class='handle-box'>


<!--                <el-select v-model='query.type' placeholder='请选择支付方式' style='width: 140px;margin-right: 20px'>-->
<!--                    <el-option-->
<!--                        v-for='item in typeOptions'-->
<!--                        :key='item.value'-->
<!--                        :label='item.label'-->
<!--                        :value='item.value'>-->
<!--                    </el-option>-->
<!--                </el-select>-->
                <el-select v-model='query.status' placeholder='请选择审批状态' style='width: 140px;margin-right: 20px'>
                    <el-option
                        v-for='item in statusOptions'
                        :key='item.value'
                        :label='item.label'
                        :value='item.value'>
                    </el-option>
                </el-select>
                <el-input v-model='query.name' placeholder='姓名' class='handle-input mr10'
                          style='width: 160px'></el-input>
<!--                <el-input v-model='query.tbrName' placeholder='投保人姓名' class='handle-input mr10'-->
<!--                          style='width: 160px'></el-input>-->
<!--                <el-input v-model='query.bbrName' placeholder='被保人姓名' class='handle-input mr10'-->
<!--                          style='width: 160px'></el-input>-->
                <el-button type='primary' icon='el-icon-search' @click='handleSearch'>查询</el-button>
<!--                <el-button type='primary' icon='el-icon-search' @click='handleSearch'>导出</el-button>-->

            </div>
            <el-table
                :data='tableData'
                border
                class='table'
                ref='multipleTable'
                header-cell-class-name='table-header'
            >
                <el-table-column type='selection' width='55' align='center' v-if='false'></el-table-column>
                <el-table-column label='序号' align='center' :index='indexMethod' width='40' type='index'>

                </el-table-column>
                <el-table-column label='姓名' align='center' >
                    <template slot-scope='scope'>{{ scope.row.name }}</template>
                </el-table-column>
                <el-table-column label='金额' align='center' >
                    <template slot-scope='scope'>{{ scope.row.amount/100 }}元</template>
                </el-table-column>

                <el-table-column label='状态' align='center'>
                    <template slot-scope='scope'>{{ scope.row.statusName}}</template>
                </el-table-column>

                <el-table-column label='打款图片' align='center'>
                    <template slot-scope='scope'>
                        <el-image

                            :fit="fit"
                            style='width: 200px; height: 200px'
                            :src='scope.row.daKuanUrl'
                            :preview-src-list='[scope.row.daKuanUrl]'>
                        </el-image>
                    </template>
                </el-table-column>

                <el-table-column label='创建时间' align='center' >
                    <template slot-scope='scope'>{{ scope.row.createTime }}</template>
                </el-table-column>

                <el-table-column label='操作'  align='center'>
                    <template slot-scope='scope'>
                        <el-button
                            type='text'
                            v-if='scope.row.status==0'
                            @click='checkOrder(scope.$index, scope.row)'
                        >审核
                        </el-button>
                        <el-button
                            type='text'
                            v-if='scope.row.status==1'
                            @click='checkPay(scope.$index, scope.row)'
                        >打款
                        </el-button>
<!--                        <el-button-->
<!--                            type='text'-->
<!--                            @click='watchOrder(scope.$index, scope.row)'-->
<!--                        >查看详情-->
<!--                        </el-button>-->
<!--                        <el-button-->
<!--                            type='text'-->
<!--                            icon='el-icon-delete'-->
<!--                            class='red'-->
<!--                            @click='handleDelete(scope.$index, scope.row)'-->
<!--                        >删除-->
<!--                        </el-button>-->

                    </template>
                </el-table-column>

            </el-table>
            <div class='pagination'>
                <el-pagination
                    background
                    layout='total, prev, pager, next'
                    :current-page='query.pageIndex'
                    :page-size='query.pageSize'
                    :total='pageTotal'
                    @current-change='handlePageChange'
                ></el-pagination>
            </div>
        </div>
        <el-dialog title='确认打款' :visible.sync='paymentVisible' width='40%'>

            <el-form ref='form' :model='createForm' label-width='160px'>
                <el-form-item label='姓名'>
                    <el-input v-model='createForm.name' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='金额(元)'>
                    <el-input v-model='createForm.amount/100' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='打款凭证'>
                    <el-upload
                        class='upload-demo'
                        :on-preview='handlePreview'
                        :on-remove='handleRemove'
                        :before-upload='beforeAvatarUpload'
                        :file-list='createForm.daKuanUrls'
                        ref='upload'

                        :http-request='uploadFileProcessUrls'
                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>
                    </el-upload>
                </el-form-item>

            </el-form>

            <span slot='footer' class='dialog-footer'>
                <el-button @click='paymentVisible = false'>取 消</el-button>
                <el-button type='primary' @click='updateDaKuanUrlById(1)'>确 定</el-button>
            </span>

        </el-dialog>

        <el-dialog title='审批' :visible.sync='checkVisible' width='40%'>

            <el-form ref='form' :model='createForm' label-width='160px'>
                <el-form-item label='姓名'>
                    <el-input v-model='createForm.name' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='金额(元)'>
                    <el-input v-model='createForm.amount/100' maxlength='11' disabled ></el-input>
                </el-form-item>
<!--                <el-form-item label='投保人企业信用代码'>-->
<!--                    <el-input v-model='createForm.tbrEnterpriseCode' maxlength='11' disabled ></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label='投保单'>-->
<!--                    <el-image-->
<!--                        style="width: 100px; height: 100px"-->
<!--                        :src="createForm.tbrTbdUrl"-->
<!--                        :preview-src-list="createForm.tbrTbdUrls">-->
<!--                    </el-image>-->

<!--                </el-form-item>-->
<!--                <el-form-item label='投保人营业执照'>-->
<!--                    <el-image-->
<!--                        style="width: 100px; height: 100px"-->
<!--                        :src="createForm.tbrYyzzUrl"-->
<!--                        :preview-src-list="createForm.tbrYyzzUrls">-->
<!--                    </el-image>-->

<!--                </el-form-item>-->


<!--                <el-form-item label='被保人姓名'>-->
<!--                    <el-input v-model='createForm.bbrName' maxlength='11' disabled ></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label='被保人电话'>-->
<!--                    <el-input v-model='createForm.bbrPhone' maxlength='11' disabled ></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label='被保人企业名称'>-->
<!--                    <el-input v-model='createForm.bbrEnterpriseName' maxlength='11' disabled ></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label='被保人企业信用代码'>-->
<!--                    <el-input v-model='createForm.bbrEnterpriseCode' maxlength='11' disabled ></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label='融资租赁合同'>-->
<!--                    <el-image-->
<!--                        style="width: 100px; height: 100px"-->
<!--                        :src="createForm.bbrZlhtUrl"-->
<!--                        :preview-src-list="createForm.bbrZlhtUrls">-->
<!--                    </el-image>-->

<!--                </el-form-item>-->
<!--                <el-form-item label='被投保人营业执照'>-->
<!--                    <el-image-->
<!--                        style="width: 100px; height: 100px"-->
<!--                        :src="createForm.bbrYyzzUrl"-->
<!--                        :preview-src-list="createForm.bbrYyzzUrls">-->
<!--                    </el-image>-->

<!--                </el-form-item>-->
<!--                <el-form-item label='付款凭证'>-->
<!--                    <el-image-->
<!--                        style="width: 100px; height: 100px"-->
<!--                        :src="createForm.fkpzUrl"-->
<!--                        :preview-src-list="createForm.fkpzUrls">-->
<!--                    </el-image>-->

<!--                </el-form-item>-->

            </el-form>
            <span slot='footer' class='dialog-footer'>
                <el-button @click='checkVisible = false'>取 消</el-button>
                 <el-button type='danger' @click='updateStatus(2)'>驳 回</el-button>
                <el-button type='primary' @click='updateStatus(1)'>通 过</el-button>
            </span>
        </el-dialog>

        <el-dialog title='查看详情' :visible.sync='watchVisible' width='40%'>

            <el-form ref='form' :model='createForm' label-width='160px'>
                <el-form-item label='保单号'>
                    <el-input v-model='createForm.tradeNo' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='保险名'>
                    <el-input v-model='createForm.baoXieName' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='保险价格'>
                    <el-input v-model='createForm.price/100' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='合伙人姓名'>
                    <el-input v-model='createForm.heHuoName' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='合伙人电话'>
                    <el-input v-model='createForm.heHuoPhone' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='合伙人企业名称'>
                    <el-input v-model='createForm.heHeoEnterpriseName' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='投保人姓名'>
                    <el-input v-model='createForm.tbrName' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='投保人电话'>
                    <el-input v-model='createForm.tbrPhone' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='投保人企业名称'>
                    <el-input v-model='createForm.tbrEnterpriseName' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='投保人企业信用代码'>
                    <el-input v-model='createForm.tbrEnterpriseCode' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='投保单'>
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="createForm.tbrTbdUrl"
                        :preview-src-list="createForm.tbrTbdUrls">
                    </el-image>

                </el-form-item>
                <el-form-item label='投保人营业执照'>
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="createForm.tbrYyzzUrl"
                        :preview-src-list="createForm.tbrYyzzUrls">
                    </el-image>

                </el-form-item>


                <el-form-item label='被保人姓名'>
                    <el-input v-model='createForm.bbrName' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='被保人电话'>
                    <el-input v-model='createForm.bbrPhone' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='被保人企业名称'>
                    <el-input v-model='createForm.bbrEnterpriseName' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='被保人企业信用代码'>
                    <el-input v-model='createForm.bbrEnterpriseCode' maxlength='11' disabled ></el-input>
                </el-form-item>
                <el-form-item label='融资租赁合同'>
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="createForm.bbrZlhtUrl"
                        :preview-src-list="createForm.bbrZlhtUrls">
                    </el-image>

                </el-form-item>
                <el-form-item label='被投保人营业执照'>
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="createForm.bbrYyzzUrl"
                        :preview-src-list="createForm.bbrYyzzUrls">
                    </el-image>

                </el-form-item>
                <el-form-item label='付款凭证'>
                    <el-image
                        style="width: 100px; height: 100px"
                        :src="createForm.fkpzUrl"
                        :preview-src-list="createForm.fkpzUrls">
                    </el-image>

                </el-form-item>

            </el-form>
        </el-dialog>

    </div>
</template>

<script>
import { countDown, formatDate, formatDates } from '@/utils/formatDate';

export default {
    name: 'basetable',
    data() {
        return {
            amountIsShow: '1',
            camountIsShow: '1',
            enterpriseId: '',
            isDiscount: '0',
            dateSelectValue: [],
            watchVisible: false,
            checkVisible:false,
            queryEnterprise: {
                name: '',
                pageIndex: 1,
                pageSize: 999999
            },
            addEnterpriseVisible: false,
            mealOptions: [],
            cardOptions: [],
            mealValue: '',
            enterpriseSearchId: '',
            query: {
                name: '',
                pageIndex: 1,
                pageSize: 10,
                status: ''
            },

            updateType: 'add',
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            addVisible: false,
            photoUrl: ''
            ,
            createForm: {

                imageUrl: '',
                tbrTbdUrls:[]

            }
            ,
            SettledEnterprise: [],
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
            options: [],
            value: '',
            editCurrentProgress: '1',
            editCurrentProgressName: '',
            typeOptions: [{ 'value': '', 'label': '请选择支付方式' }, { 'value': '0', 'label': '线下支付' }, {
                'value': '1',
                'label': '线上支付'
            }],
            statusOptions: [{ 'value': '', 'label': '请选择审批状态' }, { 'value': '0', 'label': '待审批' }, {
                'value': '1',
                'label': '通过'
            }, {
                'value': '2',
                'label': '驳回'
            }
                , {
                    'value': '3',
                    'label': '已完成'
                }],
            enterpriseOptions: [],
            enterpriseValue: '',
            specialRecruitId: '',
            paymentVisible:false


        };
    },
    watch: {},
    created() {
        this.getData();
        this.getEnterpriseData();


    },


    methods: {
        handleRemove(file,fileList) {
            this.createForm.photoUrlList=[]
            for (const fileKey in fileList) {
                this.createForm.photoUrlList.push({"url":fileList[fileKey].url})

            }

        },
        beforeAvatarUpload(file) {
            console.log('hello');
            const isJPG = file.type.includes('image');
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('文件只能是图片格式');
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!');
            }
            return isJPG && isLt2M;
        },
        uploadFileLogo(file) {
            let that = this;
            console.log('uploadFileLogo');
            this.http.postFile('/local_file', file.file).then(res => {
                // 上传成功后的处理
                if (res.data.code == 0) {
                    console.log(res.data);

                    that.createForm.imageUrl = that.http.getDownLoadUrl() + res.data.data[0];
                    let picUrl = that.createForm.imageUrl;
                    // that.createForm.photoUrlList = [];
                    that.createForm.photoUrlList.push({ url: picUrl });

                }
            }, err => {
                // 出现错误时的处理
            });
        },
        indexMethod(index) {
            return index + 1;
        },
        // 触发搜索按钮
        handleSearch() {
            this.query.pageIndex = 1;
            this.getData();

        }
        ,
        uploadFileProcessUrls(file) {
            let that = this;
            this.http.postFile('/local_file', file.file).then(res => {
                // 上传成功后的处理
                if (res.data.code == 0) {
                    console.log(res.data);

                    that.createForm.daKuanUrl = that.http.getDownLoadUrl() + res.data.data[0];
                    let picUrl = that.createForm.daKuanUrl;
                    // that.createForm.photoUrlList = [];

                    that.createForm.daKuanUrls.push({ url: picUrl });
                }
            }, err => {
                // 出现错误时的处理
            });
        },
        getData() {
            let that = this;

            this.http.getToken('/withdrawalList/getList', this.query).then(res => {
                    if (res.code == 0) {
                        that.tableData = res.data.records;
                        for (const resKey in res.data.records) {
                           let data =  res.data.records[resKey];
                           data.tbrTbdUrls = [data.tbrTbdUrl]
                            data.tbrYyzzUrls=[data.tbrYyzzUrl]
                            data.bbrYyzzUrls=[data.bbrYyzzUrl]
                            data.bbrZlhtUrls=[data.bbrZlhtUrl]
                            data.fkpzUrls = [data.fkpzUrl]
                        }

                        that.pageTotal = parseInt(res.data.total);
                        this.$message.success('获取数据成功');

                    }
                },
                err => {

                });
        },
        getSettledEnterprise(id) {
            let that = this;
            that.SettledEnterpriseId = id;
            let param = {};
            param.specialRecruitId = id;
            this.http.get('SpecialRecruit/getSettledEnterprise', param).then(res => {
                    if (res.code == 0) {
                        that.SettledEnterprise = res.data;

                    }
                },
                err => {

                });
        },
        delUserHttp(id) {
            let that = this;
            this.http.post('SpecialRecruit/delById', { 'id': id }).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        that.$message.success('删除成功');
                    }
                },
                err => {

                });
        }
        ,
        delSettledEnterpriseById(id) {
            let that = this;
            this.http.post('SpecialRecruit/delSettledEnterpriseById', { 'id': id }).then(res => {
                    if (res.code == 0) {
                        that.getSettledEnterprise(that.SettledEnterpriseId);
                        that.$message.success('删除成功');
                    }
                },
                err => {

                });
        }
        ,

        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            let that = this;
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.delUserHttp(row.id);

                })
                .catch(() => {
                });
        },
        // 删除操作
        handleWatchDelete(index, row) {

            // 二次确认删除
            let that = this;
            console.log('handleWatchDelete' + row.id);

            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.delSettledEnterpriseById(row.specialRecruitEnterpriseId);

                })
                .catch(() => {
                });
        },
        getEnterpriseData() {

            let that = this;
            console.log('getEnterpriseData' + this.query.pageSize);
            let params = {};
            params.pageSize = 99999;
            params.pageIndex = 1;
            params.status = 1;
            this.http.get('/qwpenterprise/getList', params).then(res => {
                    if (res.code == 0) {

                        that.enterpriseOptions = [];
                        for (const i in res.data.records) {
                            that.enterpriseOptions.push({
                                'value': res.data.records[i].id,
                                'label': res.data.records[i].name
                            });
                        }
                        console.log('enterpriseOptions');
                        // that.tableData = res.data.records;
                        // that.pageTotal = parseInt(res.data.total);

                    }
                },
                err => {

                });
        },
        addUser() {

            this.createForm = {};
            this.form = {};
            this.createForm.photoUrl = '';
            this.dateSelectValue = [];
            this.createForm.photoUrlList = [];

            this.addVisible = true;

        },

        addUserHttp() {
            this.updateType = 'add';
            let that = this

            that.http.postToken('/banner/add', that.createForm).then(res => {
                if (res.code === 0) {
                    that.createForm = {};
                    that.dateSelectValue = [];
                    that.getData();
                    that.addVisible = false;
                    that.$message.success('添加成功');
                }

            });

        }
        ,
        updateStatus(status) {
            let that = this;
            let params = {};
            params.status=status;
            params.id=this.createForm.id
            this.http.postToken('/withdrawalList/updateStatusById', params).then(res => {
                if (res.code == 0) {
                    that.getData();
                    this.createForm = {};
                    that.checkVisible = false;
                    that.$message.success('操作成功');
                }

            });
        }
        ,
        updateDaKuanUrlById(status) {
            let that = this;
            let params = {};
            params.status=status;
            params.id=this.createForm.id
            params.daKuanUrl=this.createForm.daKuanUrl
            this.http.postToken('/withdrawalList/updateDaKuanUrlById', params).then(res => {
                if (res.code == 0) {
                    that.getData();
                    this.createForm = {};
                    that.paymentVisible = false;
                    that.$message.success('操作成功');
                }

            });
        }
        ,
        handleStatus(index,row){
            console.log(index);
            console.log(row.uid);
            let that = this;
            let params = {};
            let msg = '';

                msg = '确定要' + '返现' + '吗？';
                params = { 'id': row.id, 'status': 1 };

            this.$confirm(msg, '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.http.postToken('/InsuranceProducts/updateOrderFanXById', params).then(res => {
                        if (res.code == 0) {
                            that.getData();
                            this.$message.success('操作成功');
                        }
                    });

                })
                .catch(() => {
                });
        },
        AddEnterpriseHttp() {
            let that = this;

            // this.$refs.uploadRef.submit()
            let params = {};
            params.enterpriseId = this.enterpriseValue;
            params.specialRecruitId = this.specialRecruitId;
            this.http.post('SpecialRecruit/addEnterprise', params).then(res => {
                if (res.code == 0) {
                    that.getSettledEnterprise(this.SettledEnterpriseId);
                    that.getData();

                    that.$message.success('添加成功');
                }

            });
        }
        ,
        // 编辑操作
        checkOrder(index, row) {
            this.idx = index;
            this.createForm = JSON.parse(JSON.stringify(row));
            this.checkVisible = true;
        },
        checkPay(index, row){
            this.idx = index;
            this.createForm = JSON.parse(JSON.stringify(row));
            this.createForm.daKuanUrls = []
            this.paymentVisible = true;
        },
        watchOrder(index, row) {
            this.idx = index;
            this.createForm = JSON.parse(JSON.stringify(row));
            this.watchVisible = true;
        },
        handleWatch(index, row) {
            this.specialRecruitId = row.id;
            // this.idx = index;
            // this.createForm = {};
            // this.createForm.name = row.name;
            // this.createForm.id = row.id;
            // this.createForm.photoUrl = row.photoUrl;
            // this.createForm.photoUrlList=[]
            // this.dateSelectValue[0]= new Date(row.startTime)
            // this.dateSelectValue[1]= new Date(row.endTime)
            // this. createForm.photoUrlList.push({pic:row.photoUrl})
            this.getSettledEnterprise(row.id);
            this.watchVisible = true;
        },
        handlePreview(file) {
            console.log('handlePreview');

        },
        // 保存编辑
        saveEdit() {
            this.editVisible = false;
            this.$message.success(`修改第 ${this.idx + 1} 行成功`);
            this.$set(this.tableData, this.idx, this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.avatar-uploader .el-upload {
    border-radius: 6px;
    width: 80px;
    height: 80px;
    text-align: center;

}

.avatar-uploader {
    border-color: #409EFF;
    text-align: center;
    margin-bottom: 40px;
    text-align: center;

}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    text-align: center;
}

.avatar {
    width: 80px;
    height: 80px;
    display: block;
    margin: auto auto;
    text-align: center;
}

.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
